import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { EbClaimHistory } from 'src/app/feature-module/reporting/models/eb-claim-history-vm';
import { AnniversaryType, LatestClaimStatus } from 'src/app/utility/enum/global-enum';
import { EbEmployeeDashboardDetailsService } from '../../service/eb-employee-dashboard-details/eb-employee-dashboard-details.service';
import { Pagination } from 'src/app/utility/services/paging/paging';
import { DialogEbClaimStatusDetailsComponent } from './dialog-eb-claim-status-details/dialog-eb-claim-status-details.component';
import { MatDialog } from '@angular/material';
import { MessageService } from 'src/app/utility/services/message/message.service';

@Component({
  selector: 'app-eb-employee-claim-details',
  templateUrl: './eb-employee-claim-details.component.html',
  styleUrls: ['./eb-employee-claim-details.component.scss']
})
export class EbEmployeeClaimDetailsComponent implements OnInit {

  latestClaimStatus = LatestClaimStatus;
  enrolId : number = null;
  @Input() set setEnrolId(value) {
    if (value) {
      this.enrolId = value;
    }
  }

  anniversaries: any[] = [
    { value: 1, name: 'Current Anniversary' },
    { value: 2, name: 'Last Anniversary' }
  ];
  members: any[] = ['All'];
  products: any[] = ['All'];
  claimHistories: EbClaimHistory[] = [];
  claimHistoriesFilteredData: EbClaimHistory[] = [];
  search = new FormControl('');
  public pagination = new Pagination();
  claimHistoryForm = this.fb.group({
    anniversary: [1],
    member: ['All'],
    product: ['All'],
    claimNo: [''],
    claimStatus: [0],
  });

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private employeeDashboardService: EbEmployeeDashboardDetailsService,
    private messageService : MessageService
  ) { }

  ngOnInit() {
    this.employeeDashboardService.getClaimHistoriesByEnrolId(this.enrolId).subscribe(
      (res: any) => {
        this.claimHistories = res.ebClaimHistoryDetails;
        this.claimHistoriesFilteredData = res.ebClaimHistoryDetails;

        let currentAnniversaryData = this.claimHistories.find(x => x.anniversaryType == AnniversaryType.CurrentAnniversary);
        if (currentAnniversaryData) {
          this.setCurrentAnniversaryDate(currentAnniversaryData.anniversaryDateRange);
        }

        this.setMembers(AnniversaryType.CurrentAnniversary);
        this.setProducts(AnniversaryType.CurrentAnniversary);
      },
      error => {
        this.messageService.show(error.error.message, "error");
      });

    this.claimHistoryForm.valueChanges.subscribe(value => {
      this.loadFilteredData(value);
    });

    this.claimHistoryForm.controls['anniversary'].valueChanges.subscribe(value => {
      this.setMembers(value);
      this.setProducts(value);
      this.claimHistoryForm.patchValue({ member: 'All', product: 'All', claimNo: '', claimStatus: 0 });
    });
  }

  loadFilteredData(value: any) {
    this.claimHistoriesFilteredData = this.claimHistories.filter(x => x.anniversaryType == value.anniversary
      && (value.member == 'All' || x.relationSuffix == value.member)
      && (value.product == 'All' || x.productName == value.product)
      && (value.claimNo == '' || (x.claimNumber.toString().toLowerCase().includes(value.claimNo.toString().toLowerCase())))
      && (value.claimStatus == 0 || x.claimCurrentStatus == value.claimStatus));
  }

  setCurrentAnniversaryDate(date) {
    this.anniversaries[0].name = 'Current Anniversary (' + date + ')';
  }

  setMembers(value) {
    this.members = ['All', ...Array.from(new Set(this.claimHistories.filter(x => x.anniversaryType == value).map(x => x.relationSuffix)))];
  }

  setProducts(value) {
    this.products = ['All', ...Array.from(new Set(this.claimHistories.filter(x => x.anniversaryType == value).map(x => x.productName)))];
  }

  toggleClaimDetails(isShowClaimDetails:boolean) {
    this.employeeDashboardService.changeSelectedViewMore(isShowClaimDetails);
  }

  applyFilter(filterBy?: string) {
    if (filterBy) {
      this.claimHistoriesFilteredData = this.claimHistories.filter(data =>
        data.claimNumber.toLocaleLowerCase().indexOf(filterBy.toLocaleLowerCase()) !== -1);
    } else {
      this.claimHistoriesFilteredData = this.claimHistories;
    }
  }

  openClaimDetailsDialog(claim) {
    const dialogRef = this.dialog.open(
      DialogEbClaimStatusDetailsComponent,
      {
        minWidth: '60%',
        data: {
          claimEntryId: claim.claimEntryId,
          claimNumber: claim.claimNumber,
          enrolId: this.enrolId
        },
        panelClass: 'custom-dialog-container'
      },
    );

    dialogRef.afterClosed().subscribe((result) => {});
  }

}